window.addEventListener('DOMContentLoaded', function () {
    const link1 = document.querySelector('#sticker-sticker-feature-logo-with-image-0');
    const link2 = document.querySelector('#sticker-sticker-feature-logo-with-image-1');

    [link1, link2].forEach(item => {
        item.classList.remove('pointer-events-none');
        item.classList.add('cursor-pointer');
    })

    link1.addEventListener('click', () => {
        window.location.href = "/pages/about";
    })

    link2.addEventListener('click', () => {
        window.location.href = "/products/lift-ticket";
    })
});